<template>
  <router-view />
</template>

<script>
export default {
  name: "app-itemCategory"
};
</script>

<style lang="scss" scoped></style>
